export class PenBridleConfigDto {
  public static ApiUrl = 'api/pen-bridle-config';

  Id: number;
  MooringConnections: number;
  Bridles: number;
  Name: string;
  NameEn: string;
  NameEs: string;
}
